import { StoreProduct } from "../../api-models";
import { InternalServerError, NotFoundError } from "../../api-models/errors";
import { StoreProductGroup } from "../../api-models";
import { ProjectId, SubscriptionEnvironment } from "../../identifiers";
import { Identifiers, Store } from "../../store";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Schema } from "effect";
export const ProductsApi = HttpApiGroup.make("products").annotate(OpenApi.Description, "Products API").add(HttpApiEndpoint.get("listStoreProducts", `/projects/:projectId/:store/:storeEnvironment/product-groups`).setPath(Schema.Struct({
    store: Store.Schema,
    storeEnvironment: SubscriptionEnvironment.Schema,
    projectId: ProjectId.FromString
})).addSuccess(Schema.Struct({
    object: Schema.Literal("list"),
    data: Schema.Array(StoreProductGroup.Schema)
})).addError(InternalServerError).addError(NotFoundError).annotate(OpenApi.Summary, "ListStoreProducts")).add(HttpApiEndpoint.get("listStorePricesForProduct", `/projects/:projectId/:store/:storeEnvironment/product-groups/:productId/prices`).setPath(Schema.Struct({
    store: Store.Schema,
    storeEnvironment: SubscriptionEnvironment.Schema,
    productId: Identifiers.StoreProductGroupId.Schema,
    projectId: ProjectId.FromString
})).addSuccess(Schema.Struct({
    object: Schema.Literal("list"),
    data: Schema.Array(StoreProduct.Schema)
})).addError(InternalServerError).addError(NotFoundError).annotate(OpenApi.Summary, "ListProductPrices"));
